<script setup lang="ts">
import { buttonProps } from 'naive-ui'

const props = defineProps(buttonProps)
</script>

<template>
  <NButton v-bind="props" quaternary type="error">
    <template #icon>
      <UIcon name="i-ic-baseline-close" />
    </template>
  </NButton>
</template>
